import React from "react";
import ReactDOM from "react-dom";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import AuthLayout from "layouts/Auth.js";
import LoginPage from "views/Pages/LoginPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "assets/scss/material-dashboard-pro-react.scss?v=1.10.0";
import ProtectedRoute from "ProtectedRoute";
import { AuthProvider } from "AuthContext";
import Unauthorized from "views/Pages/Unauthorized";
import ForgetPassword from "views/Pages/ForgetPassword";
import ResetPasswordNew from "views/Pages/ResetPasswordNew";
import Dashboard from "layouts/Admin";
import ManageLotteries from "views/Pages/ManageLotteries";
import CreateLottery from "views/Pages/CreateLottery";
import MyAccount from "views/Pages/MyAccount";
import RootRedirect from "RootRedirect";
const isAuthenticated = localStorage.getItem("token");
console.log(Dashboard, "isAuthenticated");

ReactDOM.render(
  <>
    <AuthProvider>
      <ToastContainer />
      <BrowserRouter>
        <Routes>
            <Route path="/auth/*" element={<AuthLayout />}>
            <Route path="login-page" element={<LoginPage />} />
            <Route path="forgetpassword" element={<ForgetPassword />} />
            <Route path="resetPassword/:token" element={<ResetPasswordNew />} />
            <Route index element={<Navigate to="login-page" />} />
            <Route path="my-account" element={<MyAccount />} />
          </Route>
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route element={<ProtectedRoute />}>
            {/* <Route > */}
            <Route path="/admin/*" element={<Dashboard />}>
              <Route path="ManageLotteries" element={<ManageLotteries />}>
                <Route path="createLottery" element={<CreateLottery />} />
             </Route>
              </Route>
          </Route>
         <Route />
        
              <Route path="*" element={<RootRedirect />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  </>,
  document.getElementById("root")
);
